import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start px-2 w-[40rem] self-center" }
const _hoisted_2 = { class: "flex space-x-5 mt-4" }
const _hoisted_3 = { class: "mt-10 flex justify-center items-center w-full space-x-10" }

import { PropType } from "vue"
import {
	Input,
	ModalCloseButton,
	ModalContainer,
	ModalContentContainer,
	ModalButton,
	H1,
} from "../atoms"
import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAdjustmentModal',
  props: {
	validationError: {
		type: Boolean,
		required: true,
	},

	createFit: {
		type: Function as PropType<(adjust: any) => void>,
		required: true,
	},
},
  setup(__props) {

let adjust = {
	reason: "",
	value: 0,
}

const getAdjustmentReason = () => {
	adjust.reason = adjustmentReason.value
}

const getAdjustmentValue = () => {
	adjust.value = Number(adjustmentValue.value)
}

let adjustmentValue = ref()
let adjustmentReason = ref("")



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        w: "50rem",
        h: "20rem"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(H1), { class: "text-v_dark_blue" }, {
              default: _withCtx(() => [
                _createTextVNode("Ajustar")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Input), {
                placeholder: "Motivo:",
                maxlength: 200,
                modelValue: _unref(adjustmentReason),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(adjustmentReason) ? (adjustmentReason).value = $event : adjustmentReason = $event)),
                onKeyup: getAdjustmentReason,
                class: _normalizeClass(
							__props.validationError ? '!border-v_red border-2 w-[20rem]' : 'w-[20rem]'
						)
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_unref(Input), {
                placeholder: "Valor:",
                type: "number",
                modelValue: _unref(adjustmentValue),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(adjustmentValue) ? (adjustmentValue).value = $event : adjustmentValue = $event)),
                onKeyup: getAdjustmentValue
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ModalCloseButton), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal', false))),
              class: "active:scale-90"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancelar ")
              ]),
              _: 1
            }),
            _createVNode(_unref(ModalButton), {
              enableButton: true,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.createFit(_unref(adjust)))),
              class: "active:scale-90"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Ajustar ")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})